/**
 * Core modules shared with the lazily loaded extras script (website build).
 *
 * scripts/build-widget.js rewrites imports of these modules inside the extras
 * bundle to read from window.__ReadingVoxCore, so classes like Toolbar and
 * ToolManager exist once (in the core) instead of being duplicated.
 * Keys must match SHARED_CORE_MODULES in scripts/build-widget.js.
 */

import * as Toolbar from './ui/Toolbar';
import * as ContextMenu from './ui/ContextMenu';
import * as ToggleButton from './ui/ToggleButton';
import * as ThemeManager from './ui/ThemeManager';
import * as ToolManager from './tools/ToolManager';
import * as ToolUsageTracker from './features/ToolUsageTracker';
import * as api from './utils/api';
import * as lazy from './lazy';
import * as logger from './utils/logger';
import * as sentences from './utils/sentences';

export const SHARED_CORE_MODULES: Record<string, unknown> = {
  'ui/Toolbar': Toolbar,
  'ui/ContextMenu': ContextMenu,
  'ui/ToggleButton': ToggleButton,
  'ui/ThemeManager': ThemeManager,
  'tools/ToolManager': ToolManager,
  'features/ToolUsageTracker': ToolUsageTracker,
  'utils/api': api,
  'lazy': lazy,
  'utils/logger': logger,
  'utils/sentences': sentences,
};
